// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Btn_confirm:focus {
  background-color: #ffffff !important;
  color: black !important;
  border: 1px solid;
}

.Btn_confirm:hover {
  background-color: #ffffff !important;
  color: black !important;
  border: 1px solid;
}`, "",{"version":3,"sources":["webpack://./src/app/hl7viewer/save-all-confirmation-dialog/save-all-confirmation-dialog.component.scss"],"names":[],"mappings":"AAGA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;AAFF","sourcesContent":["// Styles for Save All Confirmation Dialog\r\n// Matches application's generic popup styling (xmlMappings/confirm-dialog pattern)\r\n\r\n.Btn_confirm:focus {\r\n  background-color: #ffffff !important;\r\n  color: black !important;\r\n  border: 1px solid;\r\n}\r\n\r\n.Btn_confirm:hover {\r\n  background-color: #ffffff !important;\r\n  color: black !important;\r\n  border: 1px solid;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
